export default "__VITE_ASSET__CgnjquCl__"